<template>
  <div class="video-mark-popover">
    <button class="mark-btn" @click="handleMarkBtn">
      <img src="../../../assets/images/video/mark.png" alt="" />
    </button>
    <div class="popover-list" v-if="isShow">
      <div
        v-for="item in markList"
        :key="item.type"
        class="popover-item"
        @click="handleClick(item)"
      >
        <span class="icon-box">
          <img :src="item.image" />
        </span>
        <span class="item-title">{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoMarkPopover",
  props: {
    value: Boolean,
  },
  data() {
    return {
      isShow: false,
      markList: [
        {
          type: "key",
          title: "重点",
          image: require("../../../assets/images/video/keynote.png"),
          id: 2,
        },
        {
          type: "question",
          title: "疑问点",
          image: require("../../../assets/images/video/doubt-point.png"),
          id: 3,
        },
        {
          type: "custom",
          title: "自定义",
          image: require("../../../assets/images/video/customize.png"),
          id: 1,
        },
      ],
    };
  },
  mounted() {
    // 监听页面点击其他地方关闭音量控制
    document.addEventListener("click", this.clickOutside);
  },
  beforeDestroy() {
    // 移除页面点击事件监听
    document.removeEventListener("click", this.clickOutside);
  },
  methods: {
    // 监听页面点击事件
    clickOutside(event) {
      const target = event.target;
      if (!this.$el.contains(target)) {
        this.isShow = false;
      }
    },
    handleMarkBtn() {
      this.isShow = !this.isShow;
    },
    handleClick({ type, title, id }) {
      this.$emit("select", {
        type,
        title,
        id,
      });
      this.isShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.video-mark-popover {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .mark-btn {
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .popover-list {
    position: absolute;
    top: -145px;
    left: -12px;
    min-width: 94px;
    width: max-content;
    min-height: 104px;
    background-color: rgba($color: #14171c, $alpha: 0.9);
    border-radius: 12px;
    padding-top: 4px;
    padding-left: 6px;
    padding-right: 6px;
  }

  .popover-item {
    display: flex;
    align-items: center;
    padding: 6px 8px 6px 6px;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      background: rgba(81, 88, 103, 0.7);
      border-radius: 12px;
    }
    .icon-box {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
    .item-title {
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
    }
  }
}

// .popover-list {
//   display: flex;
//   flex-direction: column;
//   gap: 8px;
//   width: 94px;
//   height: 104px;
//   background-color: rgba($color: #14171c, $alpha: 0.9);
//   border-radius: 12px;
// }
// .popover-item {
//   display: flex;
//   align-items: center;
//   padding: 8px 20px;
//   cursor: pointer;
//   color: #fff;
//   font-size: 18px;
//   transition: background 0.2s;
// }
// .popover-item:hover {
//   background: rgba(255, 255, 255, 0.08);
// }
// .icon-box {
//   width: 32px;
//   height: 32px;
//   border: 1px dashed #fff;
//   border-radius: 8px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-right: 12px;
// }
// .icon-box img {
//   width: 20px;
//   height: 20px;
// }
// .mark-btn {
//   background: none;
//   border: none;
//   padding: 0;
//   cursor: pointer;
// }
// .mark-btn img {
//   width: 32px;
//   height: 32px;
// }
</style>
